import type { TutorApplicationStore } from './interfaces'

import { ReferralSource } from '@ts-tutor-application/enums'

const isMainInformationValid = (state: TutorApplicationStore): boolean => {
  return (
    !!state.fullName &&
    !!state.email &&
    state.emailValid &&
    !!state.phoneNumber &&
    !!state.cv &&
    !!state.coverLetter
  )
}

const isAdditionQuestionsValid = (state: TutorApplicationStore): boolean => {
  const isReferralValid = state.recommended ? !!state.referrerFullName : true
  const isReferralSourceValid = (state.referralSource === ReferralSource.JobBoard ? !!state.jobPostingSite : true)

  return (
    state.nationality !== null &&
    state.ageConfirmation !== null &&
    state.recommended !== null &&
    isReferralValid &&
    !!state.referralSource &&
    isReferralSourceValid &&
    state.hasBachelorDegree !== null &&
    !!state.teachingExperienceYears &&
    state.workRequiredSchedule !== null &&
    !!state.onboardingTimeframe
  )
}

const isLegalAgreementsValid = (state: TutorApplicationStore): boolean => {
  return (
    state.acceptEmailDelivery &&
    state.acceptConfidentiality &&
    state.acceptNotRestrictedResident &&
    state.acceptDataProcessingTerms
  )
}

export const getters = {
  getFullName: (state: TutorApplicationStore): string => state.fullName,
  getEmail: (state: TutorApplicationStore): string => state.email,
  getPhoneNumber: (state: TutorApplicationStore): string => state.phoneNumber,
  getCv: (state: TutorApplicationStore): File | File[] | null => state.cv,
  getCoverLetter: (state: TutorApplicationStore): File | File[] | null => state.coverLetter,
  getNationality: (state: TutorApplicationStore): string => state.nationality,
  getAgeConfirmation: (state: TutorApplicationStore): boolean | null => state.ageConfirmation,
  getRecommended: (state: TutorApplicationStore): boolean | null => state.recommended,
  getReferrerFullName: (state: TutorApplicationStore): string => state.referrerFullName,
  getReferralSource: (state: TutorApplicationStore): TutorApplicationStore['referralSource'] => state.referralSource,
  getJobPostingSite: (state: TutorApplicationStore): string => state.jobPostingSite,
  getHasBachelorDegree: (state: TutorApplicationStore): boolean | null => state.hasBachelorDegree,
  getTeachingExperienceYears: (state: TutorApplicationStore): TutorApplicationStore['teachingExperienceYears'] => state.teachingExperienceYears,
  getWorkRequiredSchedule: (state: TutorApplicationStore): boolean | null => state.workRequiredSchedule,
  getOnboardingTimeframe: (state: TutorApplicationStore): TutorApplicationStore['onboardingTimeframe'] => state.onboardingTimeframe,
  getAcceptEmailDelivery: (state: TutorApplicationStore): boolean => state.acceptEmailDelivery,
  getAcceptConfidentiality: (state: TutorApplicationStore): boolean => state.acceptConfidentiality,
  getAcceptNotRestrictedResident: (state: TutorApplicationStore): boolean => state.acceptNotRestrictedResident,
  getAcceptDataProcessingTerms: (state: TutorApplicationStore): boolean => state.acceptDataProcessingTerms,
  isEmailValid: (state: TutorApplicationStore): boolean => state.emailValid,
  getShowErrors: (state: TutorApplicationStore): boolean => state.showErrors,
  getAmplitudeId: (state: TutorApplicationStore): string | null => state.amplitudeId,

  isValid: (state: TutorApplicationStore): boolean => {
    return (
      isMainInformationValid(state) &&
      isAdditionQuestionsValid(state) &&
      isLegalAgreementsValid(state)
    )
  },
}
